import { render } from "./TemplateIntegrationList.vue?vue&type=template&id=18405707"
import script from "./js/templateIntegrationList.js?vue&type=script&lang=js&external"
export * from "./js/templateIntegrationList.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__